module.exports = __webpack_public_path__ + "01_hige_black.894bb9c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer3/01_hige_black.png
// module id = lgxR
// module chunks = 0